import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { shape, func } = proptypes;
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import {
  getNearbyStoreWithLimitedStock, formatDistance, productShape
} from '../../helpers/pod-fulfillment-utils';
import { CheckNearByStore } from './CheckNearbyStore';
import { LimitedStockIcon, AtYourStoreIcon } from '../../helpers/icon-utils';
import { isMobile, isFunction } from '../../../components/helper/utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';
import { PodMessage } from '../PodMessage';

export const LimitedAvailabilityNearby = ({
  product,
  onCheckNearbyStoresClick,
  customRender
}) => {
  const { channel } = useContext(ExperienceContext);
  const enablePLPFasterDeliveryOption = !!useConfigService('fs:enablePLPFasterDeliveryOption');
  const nearbyStore = getNearbyStoreWithLimitedStock(product);
  const limitedStockIcon = enablePLPFasterDeliveryOption ? AtYourStoreIcon : LimitedStockIcon;

  const emptyComponent = () => {
    if (isFunction(customRender)) {
      return customRender({
        pickUpTemplate: PICKUP_TEMPLATES.EMPTY_STORE_MESSAGE,
        isEmptyComponent: true,
        icon: null,
        value: {}
      });
    }
    return (<div className="sui-flex" />);
  };

  if (!(product && nearbyStore)) {
    return emptyComponent();
  }

  const { storeName, distance } = nearbyStore;
  const distanceDisplay = enablePLPFasterDeliveryOption ? ` (${formatDistance(distance)} mi)` : '';

  if (!(storeName && distance)) {
    return emptyComponent();
  }

  const storeNameLink = (
    <CheckNearByStore
      product={product}
      onCheckNearbyStoresClick={onCheckNearbyStoresClick}
      nearbyStoreName={storeName}
    />
  );

  if (isFunction(customRender)) {
    return customRender(
      {
        pickUpTemplate: PICKUP_TEMPLATES.LIMITED_AVAILABILITY_NEARBY,
        icon: LimitedStockIcon,
        values:
          { storeNameLink, storeName, distance: formatDistance(distance) }
      });
  }

  return (
    <PodMessage
      messageIcon={limitedStockIcon}
      messageType={enablePLPFasterDeliveryOption ? 'Limited Stock Nearby' : 'Pickup Nearby'}
      isStoreNameAtEnd
    >
      <>
        {enablePLPFasterDeliveryOption ? 'at ' : 'Limited stock at '}
        {storeNameLink}
        <span className="sui-text-primary">{enablePLPFasterDeliveryOption ? distanceDisplay : ''}</span>
      </>
    </PodMessage>
  );
};

LimitedAvailabilityNearby.propTypes = {
  product: shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: func,
  customRender: func
};

LimitedAvailabilityNearby.defaultProps = {
  onCheckNearbyStoresClick: () => { },
  customRender: null
};
